import React, { useContext, useState, useEffect, useRef } from 'react'
const TimerProviderContext = React.createContext();

export function useTimerProvider() {
    return useContext(TimerProviderContext)
}

export function TimerProvider({ children }) {
    // const streams = useRef({ video: null, segmentation: null, rcv: null });
    const [configTimer, setConfigTimer] = useState({
        'label': '',
        'start': 0,
        'end': 0,
        'step': 1,
        'interval_ms': 1000,
        'onEnd': () => sendMsg('Timer ended')
    });
    const [timer, setTimer] = useState(configTimer.start);
    const stop_timer_ref = useRef(false)
    const [timerActive, setTimerActive] = useState(false);
    const [timerSpeed, setTimerSpeed] = useState(1);

    useEffect(() => {
        stop_timer_ref.current = false
        if (!timerActive){
            setTimer(configTimer.start)
        }
    }, [configTimer])

    useEffect(() => {
        console.log("🚀 ~ TimerProvider ~ timerSpeed:", timerSpeed)
    }, [timerSpeed])


    useEffect(() => {
        console.log('Timer -  timer: ', timer, 'vs end: ', configTimer.end)
        if (timer > configTimer.end && stop_timer_ref.current == false){
            setTimerActive(configTimer['label'])
            if (configTimer['label'] == 'Recording'){
                setTimeout(() => {
                    setTimer(timer - 1)
                }, configTimer.interval_ms * timerSpeed)
            }else{
                setTimeout(() => {
                    setTimer(timer - 1)
                }, configTimer.interval_ms)
            }
        } else {
            setTimer(0)
            setTimerActive('')
            configTimer.onEnd()
        }
    }, [timer])


    function sendMsg(msg){
        console.log("🚀 ~ sendMsg ~ msg:", msg)
    }

    function stopTimer(){
        console.log("🚀 ~ SOLICITAR STOP TIMER")
        stop_timer_ref.current = true
    }


    /* Exported values */
    const value = {
        timer,
        timerActive,
        configTimer,
        timerSpeed,
        setTimerSpeed,
        setConfigTimer,
        stopTimer
    }

    return (
        <TimerProviderContext.Provider value={value}>
            {children}
        </TimerProviderContext.Provider>
    )
}